import { localizeSystemText } from '../../../i18n/messages';
import React from "react";
import PropTypes from "prop-types";
import Input from "../../common/Input";
import SelectInput from "../../common/SelectInput";
import { CLASS_TYPES, STATUS } from "../../common/Const";
import {
  CHARGING_STRATEGIES,
  DURATION_POLICIES,
  PARTICIPATION_STRATEGIES,
  PAYMENT_STRATEGIES,
} from "../../billingEnrollment/billingEnrollmentTypes";
import {
  CHARGING_LABELS,
  DURATION_LABELS,
  PARTICIPATION_LABELS,
  PAYMENT_LABELS,
  enumOptions,
} from "./productDisplay";
import { useTranslation } from 'react-i18next';

function ProductForm({
  product,
  classTypes,
  errors,
  onChange,
  onSubmit,
  onCancel,
  status,
}) {
  const { t: tr } = useTranslation();
  const disabled = status === STATUS.SUBMITTING;
  const classTypeOptions = classTypes.map(classType => ({ value: classType.id, text: classType.name }));

  return (
    <form id="product-form" onSubmit={onSubmit}>
      <h2 className="manage-title">{tr("manage:product_186")}</h2>
      <div className="form-row">
        <div className="col-md-6">
          <Input label={tr("manage:name_281")} name="name" value={product.name || ""} error={errors.name} onChange={onChange} />
        </div>
        <div className="col-md-3">
          <Input label={tr("manage:defaultPrice_282")} name="defaultPrice" type="number" value={String(product.defaultPrice || "")} onChange={onChange} />
        </div>
        <div className="col-md-3">
          <Input label={tr("manage:validityInDays_283")} name="validForDays" type="number" value={String(product.validForDays || "")} onChange={onChange} />
        </div>
      </div>
      <div className="form-row">
        <div className="col-md-3">
          <SelectInput
            label={tr("manage:participation_194")}
            name="participationStrategy"
            value={product.participationStrategy || ""}
            defaultOption="Wybierz"
            options={enumOptions(PARTICIPATION_STRATEGIES, PARTICIPATION_LABELS).map(option => ({ ...option, text: localizeSystemText(option.text, tr) }))}
            error={errors.participationStrategy}
            onChange={onChange}
          />
        </div>
        <div className="col-md-3">
          <SelectInput
            label={tr("manage:payment_192")}
            name="paymentStrategy"
            value={product.paymentStrategy || ""}
            defaultOption="Wybierz"
            options={enumOptions(PAYMENT_STRATEGIES, PAYMENT_LABELS).map(option => ({ ...option, text: localizeSystemText(option.text, tr) }))}
            error={errors.paymentStrategy}
            onChange={onChange}
          />
        </div>
        <div className="col-md-3">
          <SelectInput
            label={tr("manage:charging_193")}
            name="chargingStrategy"
            value={product.chargingStrategy || ""}
            defaultOption="Wybierz"
            options={enumOptions(CHARGING_STRATEGIES, CHARGING_LABELS).map(option => ({ ...option, text: localizeSystemText(option.text, tr) }))}
            error={errors.chargingStrategy}
            onChange={onChange}
          />
        </div>
        <div className="col-md-3">
          <SelectInput
            label={tr("manage:duration_284")}
            name="durationPolicy"
            value={product.durationPolicy || ""}
            defaultOption="Wybierz"
            options={enumOptions(DURATION_POLICIES, DURATION_LABELS).map(option => ({ ...option, text: localizeSystemText(option.text, tr) }))}
            error={errors.durationPolicy}
            onChange={onChange}
          />
        </div>
      </div>
      <div className="form-row">
        <div className="col-md-3">
          <Input
            label={tr("manage:numberOfLessons_195")}
            name="packageUnits"
            type="number"
            value={String(product.packageUnits || "")}
            error={errors.packageUnits}
            onChange={onChange}
          />
        </div>
        <div className="col-md-3">
          <SelectInput
            label={tr("manage:lessonType_196")}
            name="classTypeId"
            value={product.classTypeId || ""}
            defaultOption="Wybierz"
            options={classTypeOptions}
            error={errors.classTypeId}
            onChange={onChange}
          />
        </div>
      </div>
      <div className="pt-4 row mx-0">
        <div className="ml-auto col-md-block">
          <button type="submit" className="btn manage-button manage-red-button btn-block" disabled={disabled}>
            {disabled ? "Zapisywanie..." : tr("common:save")}
          </button>
        </div>
        <div className="col-md-block pl-2 pr-2">
          <button type="button" className="btn manage-button manage-teal-button btn-block" disabled={disabled} onClick={onCancel}>{tr("manage:back_128")}</button>
        </div>
      </div>
    </form>
  );
}

ProductForm.propTypes = {
  product: PropTypes.object.isRequired,
  classTypes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    length: PropTypes.number,
  })),
  errors: PropTypes.objectOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
};

ProductForm.defaultProps = {
  classTypes: CLASS_TYPES,
  errors: {},
};

export default ProductForm;
